/* JUST FLOW - collection card swatches (Simon 2026-08-10)
   Pairs with assets/jf-cards.css.

   WHAT THIS DOES
   1. Clicking a colour swatch swaps the card image to that colour.
   2. Caps the swatch row at 6 and adds a +N chip that EXPANDS.

   HOW THE IMAGE SWAP WORKS - verified live on /collections/shirts
   2026-08-10, do NOT re-derive:
   - Horizon's own ProductCard.previewVariant() / previewImage() /
     resetImage() all EXIST but do nothing on collection cards.
     slideshow-component carries disabled="true" and its .slides
     API reports 1 while the DOM holds 12. select() is a no-op.
   - The 8/09 note concluded matching was impossible because
     "slides have data-media-id = null". They do. But each slide
     carries slide-id, and on the pilot card all 11 swatch
     data-media-id values matched a slide-id exactly, 11 of 11.
   - Visibility is the plain HTML hidden attribute: the shown
     slide has no hidden, the rest have it. display:none/flex
     follows from that. No transforms, no scrolling, no classes.
   So the swap is: remove hidden from the matching slide, add it
   to the others. That is the whole mechanism.

   The slide with NO variant-image attribute is the lifestyle
   hero (position 1 per the Constitution) and is the fallback. */
(function () {
  var CAP = 6;

  function showOnly(slides, target) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i] === target) slides[i].removeAttribute('hidden');
      else slides[i].setAttribute('hidden', '');
    }
  }

  function addMoreChip(card) {
    var items = card.querySelectorAll('product-swatches li.variant-option__swatch');
    if (items.length <= CAP) return;
    var list = items[0].parentElement;
    if (!list || list.querySelector('li.jf-more')) return;

    for (var i = CAP; i < items.length; i++) items[i].style.display = 'none';

    var hidden = items.length - CAP;
    var li = document.createElement('li');
    li.className = 'jf-more';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'jf-more';
    btn.textContent = '+' + hidden;
    btn.setAttribute('aria-label', 'Show ' + hidden + ' more colours');

    btn.addEventListener('click', function (event) {
      /* the whole card is a link - do not navigate */
      event.preventDefault();
      event.stopPropagation();
      for (var i = 0; i < items.length; i++) items[i].style.display = '';
      if (li.parentNode) li.parentNode.removeChild(li);
    });

    li.appendChild(btn);
    list.appendChild(li);
  }

  function wireCard(card) {
    if (card.getAttribute('data-jf-cards')) return;
    var slideshow = card.querySelector('slideshow-component');
    var swatches = card.querySelector('product-swatches');
    if (!slideshow || !swatches) return;

    var slides = Array.prototype.slice.call(
      slideshow.querySelectorAll('slideshow-slide')
    );
    if (slides.length < 2) return;

    card.setAttribute('data-jf-cards', '1');

    var fallback = null;
    for (var i = 0; i < slides.length; i++) {
      if (!slides[i].hasAttribute('variant-image')) { fallback = slides[i]; break; }
    }
    if (!fallback) fallback = slides[0];

    var inputs = swatches.querySelectorAll('input[type="radio"]');
    Array.prototype.forEach.call(inputs, function (input) {
      input.addEventListener('change', function () {
        var label = input.closest('label');
        var id = input.getAttribute('data-option-media-id') ||
                 (label && label.getAttribute('data-media-id'));
        var target = null;
        if (id) {
          for (var i = 0; i < slides.length; i++) {
            if (slides[i].getAttribute('slide-id') === id) { target = slides[i]; break; }
          }
        }
        showOnly(slides, target || fallback);
      });
    });

    addMoreChip(card);
  }

  function run() {
    var cards = document.querySelectorAll('product-card');
    Array.prototype.forEach.call(cards, wireCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  /* re-wire cards added by pagination, filtering or infinite scroll.
     childList only - the swap toggles an ATTRIBUTE, so it cannot
     retrigger this and loop. rAF-debounced. */
  var pending = false;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () { pending = false; run(); });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
